import type { Unit } from '../data/model'
import type { PriceAdviceResult } from './priceAdvice'
import type { PriceCountry, PriceCurrency, SafePriceRequest } from '../../supabase/functions/_shared/aiRequest'

export type { PriceCountry, SafePriceRequest }
export const priceCountry = (value: string): PriceCountry =>
  ['AT', 'DE', 'CH', 'GB', 'US'].includes(value) ? value as PriceCountry : 'OTHER'
// Unsupported currencies must fail validation, never silently change the unit of money.
const currency = (value: string): PriceCurrency => value as PriceCurrency
const whole = (value: number | null | undefined): number | null => value == null ? null : Math.round(value)
export function coldPriceRequest(input: {
  today: string; de: boolean; currency: string; country: PriceCountry; character: number; audience: number
  units: Unit[]; currentBasePrice: number | null
}): SafePriceRequest {
  return {
    version: 1, language: input.de ? 'de' : 'en', currency: currency(input.currency), today: input.today,
    data: {
      kind: 'cold_start', country: input.country, character: input.character, audience: input.audience,
      currentBasePrice: whole(input.currentBasePrice),
      units: input.units.filter(u => u.active).slice(0, 25).map(u => ({
        kind: u.kind, size: whole(u.size_sqm), bedrooms: whole(u.bedrooms), capacity: u.max_occupancy,
      })),
    },
  }
}
export function occupancyPriceRequest(input: {
  today: string; de: boolean; currency: string; result: PriceAdviceResult
}): SafePriceRequest {
  const r = input.result
  return {
    version: 1, language: input.de ? 'de' : 'en', currency: currency(input.currency), today: input.today,
    data: {
      kind: 'occupancy', averagePrice: Math.round(r.averagePrice),
      spans: r.spans.map(s => ({
        from: s.from, to: s.lastDay, occupancyPct: Math.round(s.occupancy * 100),
        currentPrice: Math.round(s.averagePrice), hasSeason: s.kind !== 'no_season', schoolHoliday: s.holidayRegions.length > 0,
      })),
      weekend: r.weekend ? {
        weekendPct: Math.round(r.weekend.weekendOccupancy * 100), weekdayPct: Math.round(r.weekend.weekdayOccupancy * 100),
      } : null,
    },
  }
}
